module.exports = __webpack_public_path__ + "img/QuickReplyOutlined.915ace6d.png";